import React from "react";
import { createPortal } from "react-dom";
import { resolveConfirm } from "./confirm";

export function ConfirmHost() {
    const [open, setOpen] = React.useState(false);
    const [message, setMessage] = React.useState("");
    const [confirmLabel, setConfirmLabel] = React.useState("확인");

    React.useEffect(() => {
        const onEvt = (e: any) => {
            const msg = String(e?.detail?.message ?? "");
            if (!msg) return;
            setMessage(msg);
            setConfirmLabel(e?.detail?.confirmLabel || "확인");
            setOpen(true);
        };
        window.addEventListener("bt:confirm", onEvt);
        return () => window.removeEventListener("bt:confirm", onEvt);
    }, []);

    const handleConfirm = () => {
        setOpen(false);
        resolveConfirm(true);
    };

    const handleCancel = () => {
        setOpen(false);
        resolveConfirm(false);
    };

    if (!open) return null;

    return createPortal(
        <div
            onClick={handleCancel}
            style={{
                position: "fixed",
                inset: 0,
                background: "rgba(0,0,0,.35)",
                display: "grid",
                placeItems: "center",
                zIndex: 5000,
                padding: 16,
            }}
        >
            <div
                onClick={(e) => e.stopPropagation()}
                style={{
                    width: "min(340px, 85vw)",
                    background: "#fff",
                    borderRadius: 14,
                    boxShadow: "0 8px 24px rgba(0,0,0,.18)",
                    padding: "24px 20px 18px",
                }}
            >
                <div style={{ fontWeight: 600, fontSize: 15, color: "#222", lineHeight: 1.5, textAlign: "center", wordBreak: "keep-all" }}>
                    {message}
                </div>

                <div style={{ height: 18 }} />

                <div style={{ display: "flex", gap: 10 }}>
                    <button
                        onClick={handleCancel}
                        style={{
                            flex: 1,
                            height: 44,
                            borderRadius: 10,
                            border: "1px solid #ddd",
                            background: "#fff",
                            color: "#333",
                            fontSize: 14,
                            fontWeight: 600,
                            cursor: "pointer",
                        }}
                    >
                        취소
                    </button>
                    <button
                        onClick={handleConfirm}
                        style={{
                            flex: 1,
                            height: 44,
                            borderRadius: 10,
                            border: "none",
                            background: "#111",
                            color: "#fff",
                            fontSize: 14,
                            fontWeight: 600,
                            cursor: "pointer",
                        }}
                    >
                        {confirmLabel}
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
}
